<script setup lang="ts">
import { RouterView } from "vue-router";
import { onErrorCaptured } from "vue";

onErrorCaptured((err, instance, info) => {
  console.error("Global error captured:", err);
  console.error("Error info:", info);
  console.error("Component instance:", instance);

  // Return false to prevent error from propagating further
  return false;
});
</script>

<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<style>
@import "./assets/styles/main.css";

#app {
  min-height: 100vh;
  background-color: var(--color-background);
}
</style>
